import TalentCard from './TalantCard'
import ApplicationCard from './ApplicationCard'
import FavoriteCard from './FavoriteCard'

export default function install(Vue) {
  Vue.component(TalentCard.name, TalentCard)
  Vue.component(ApplicationCard.name, ApplicationCard)
  Vue.component(FavoriteCard.name, FavoriteCard)
}
